<template>
  <div class="my-published-bookshelf-area">
    <el-scrollbar ref="scrollbar">
      <div class="my-published-bookshelf" id="js-published-bookshelf">
        <div class="bookshelf-item add-bookshelf-div" v-show="booksCurrentSubAccount == ''" @click="clickAddBooklib">
          <img src="@imgs/add-book.png" alt="" />
          <div>创建新链接作品</div>
        </div>
        <div class="bookshelf-item normal" v-for="item in shelfLinkData.dataList" v-bind:key="item.id">
          <div class="bookshelf-bg-container" @click="clickViewBookshelf(item)">
            <img :src="item.backgroud" alt="" />
            <!-- <img src="@imgs/bookshelf/bookshelf_bg.png" alt="" /> -->
          </div>
          <div class="info-and-deal">
            <div class="title">
              <div class="title-name">
                <span class="name">{{ item.title }}</span>
                <span>{{ getTime(item.updateTime) }}</span>
              </div>
            </div>
            <div class="deal-btn-wrapper" style="margin-top: 40px;">
              <el-tooltip v-show="booksCurrentSubAccount == ''" effect="dark" content="编辑" placement="bottom" v-if="item.readModel != 1">
                <img class="deal-btn icon-style" src="@imgs/compile.png" @click="clickEditLinkBook(item)" />
              </el-tooltip>
              <el-tooltip v-show="booksCurrentSubAccount == '' || !isSubAccount" effect="dark" content="删除" placement="bottom" v-if="item.readModel != 1">
                <img class="deal-btn icon-style" src="@imgs/delete-icon.png" @click="clickDelLinkBook(item.id)" />
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </el-scrollbar>
    <elPagination1 class="page-component" :layout="'prev, pager, next'" :total="shelfLinkData.totalCount" :currentPage="currentPageNo" :pageSize="11" @handleCurrentChange="currentPageChange">
      <slot>
        共<span class="text-yellow">{{ shelfLinkData.totalCount }}</span
        >条记录
      </slot>
    </elPagination1>
    <AddLinks ref="AddLinks" :type="type" :echoData="echoData" @undataPage="undataPage" @addLinkImg="addLinkImg" @getFile="getFile" />
    <!-- 非会员新建专辑弹框 -->
    <tip-dialog ref="memberDialog" :dialogOptions="memberDialogOptions"></tip-dialog>
    <TipDialog ref="deleteDialog" :dialogOptions="deleteDialogOptions" @clickConfirm="deleteConfirm"></TipDialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import elPagination1 from '@components/common/elPagination.vue'
import AddLinks from './AddLinks'
import TipDialog from '@components/common/TipDialog.vue'
import LinkPubilshen from '@api/LinkPubilshen'
import apis from '@api/setBook'
import compareVipRight from '@components/common/compareVipRight.js'
export default {
  name: 'linkPublished',
  data() {
    return {
      type: 0,
      DelCurId: '',
      currentPageNo: 1,
      // 删除专辑弹框配置项
      deleteDialogOptions: {
        // 弹框类型
        type: 'delete',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: '作品删除后无法恢复，是否确认删除?'
      },
      file: null,
      echoData: {
        title: '链接作品',
        url: '',
        backgroud: '',
        creator: this.$store.state.common.userName,
        coverSize: '765,1031'
      }
    }
  },
  props: {
    shelfLinkData: Object
  },
  mixins: [compareVipRight],
  components: { AddLinks, TipDialog, elPagination1 },
  computed: {
    ...mapState('manage', ['booksCurrentSubAccount']),
    isSubAccount() {
      return this.$store.state.common.isSubAccount
    },
    memberDialogOptions() {
      return {
        // 弹框类型
        type: 'member',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: `您当前为${this.$store.state.common.vipRight.name}，使用此功能需先升级会员服务！`
      }
    }
  },
  methods: {
    async setBackgroundCustom(payload, data) {
      let params = new FormData()
      let waitData = null
      if (payload !== 'background') {
        waitData = base64ToFile(data) || ''
      } else {
        waitData = data
      }
      params.append('fieldName', payload)
      params.append(payload, waitData)
      return apis.uploadPicture(params)
    },
    async picChangeUrl(payload, data) {
      const result = await this.setBackgroundCustom(payload, data)
      if (result && result.data.code === 0) {
        return result.data.data
      }
    },
    //翻页
    currentPageChange(val) {
      this.currentPageNo = val
      this.$emit('changePage', val)
    },

    // 编辑
    clickEditLinkBook(item) {
      this.$refs.AddLinks.open = true
      let a = item
      this.echoData = a
      this.type = 1
    },
    // 删除
    clickDelLinkBook(id) {
      this.$refs.deleteDialog.visible = true
      this.DelCurId = id
    },
    // 删除链接作品
    deleteConfirm() {
      LinkPubilshen.delLinkWorks({ ids: this.DelCurId }).then((res) => {
        this.$parent.getLinkList(this.currentPageNo)
      })
    },
    // 查看链接作品
    clickViewBookshelf(item) {
      window.open(item.url, '_blank')
    },
    async clickAddBooklib() {
      if (!(await this.compareRight({ type: 'boole', key: 'linkWork' }))) {
        this.$refs.memberDialog.visible = true
      } else {
        this.$refs.AddLinks.open = true
        this.echoData = {
          title: '链接作品',
          url: '',
          backgroud: '',
          creator: this.$store.state.common.userName,
          coverSize: '765,1031'
        }
        this.type = 0
      }
    },
    undataPage() {
      if (this.file) {
        this.$emit('changePage', this.currentPageNo)
      }
    },
    // 新建专辑或者图书馆
    async addLinkImg(params, type) {
      let a = {}
      a.title = params.title
      a.url = params.url
      a.creator = this.$store.state.common.userName
      a.coverSize = '765,1031'
      a.backgroud = params.backgroud.substr(params.backgroud.indexOf('attach'))
      if (this.file) {
        this.cusBg = await this.picChangeUrl('background', this.file)
        a.backgroud = this.cusBg
      }
      if (type == 0) {
        LinkPubilshen.setLinkWords(a).then((res) => {
          if (res.status === 200) {
            this.$refs.AddLinks.open = false
            this.$parent.getLinkList(this.currentPageNo)
            this.$refs.AddLinks.ruleForm.url = ''
            this.$refs.AddLinks.ruleForm.backgroud = ''
            this.$refs.AddLinks.ruleFormBackgroud = ''
            this.$refs.AddLinks.ruleForm.creator = ''
            this.file = ''
          }
        })
      } else if (type == 1) {
        a.id = params.id
        LinkPubilshen.editLinkWorks(a).then((res) => {
          if (res.status === 200) {
            this.$refs.AddLinks.open = false
            this.$parent.getLinkList(this.currentPageNo)
            this.$refs.AddLinks.ruleForm.url = ''
            this.$refs.AddLinks.ruleForm.backgroud = ''
            this.$refs.AddLinks.ruleFormBackgroud = ''
            this.$refs.AddLinks.ruleForm.creator = ''
            this.file = ''
          }
        })
      }
    },
    getTime(timestamp) {
      var date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-'
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
      var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
      var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
      var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()

      let strDate = Y + M + D + h + m + s
      return strDate
      //输出样式：2020-10-25 14:25:36
    },
    getFile(file) {
      this.file = file
    }
  }
}
</script>
<style lang="scss" scoped>
.my-published-bookshelf-area {
  .bookshelft-header-div {
    padding: 8px 0;
    .bookshelf-header {
      font-size: 17px;
      margin-right: 18px;
      color: #000;
      font-weight: 400;
    }
    .num-info {
      font-size: 16px;
      display: inline-block;
    }
  }
  .my-published-bookshelf {
    padding-top: 16px;
    height: calc(100vh - 220px);
    min-height: 360px;
    overflow-y: auto;
    .bookshelf-item {
      display: inline-block;
      vertical-align: top;
      width: 249px;
      height: 340px;
      border: 1px solid rgba(232, 232, 232, 1);
      color: rgba(255, 255, 255, 0.8);
      margin-right: 10px;
      margin-bottom: 10px;
      position: relative;
      color: #fff;
      line-height: 20px;
      cursor: pointer;
      .shade {
        position: absolute;
        width: 100%;
        height: 100%;
        font-size: 14px;
        background: rgba(0, 0, 0, 0.5);
        top: 0;
        left: 0;
        cursor: default;
        display: flex;
        flex-direction: column;
      }
      .get-book {
        height: 280px;
        width: 100%;
      }
      .bookshelf-bg-container {
        position: relative;
        width: 100%;
        height: 100%;
        // height: calc(100% - 80px);
      }
      .info-and-deal {
        position: relative;
        display: none;
        position: absolute;
        width: 100%;
        height: 80px;
        background: rgba(0, 0, 0, 0.5);
        bottom: 0;
        left: 0;
        padding: 0 5px;
        line-height: 21px;
        font-size: 14px;
        .title {
          position: absolute;

          padding: 4px 0;
          .title-name {
            text-align: left;
            display: flex;
            flex-direction: column;
            flex: 1;
            text-align: left !important;

            .name {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              width: 249px;
            }
          }
          .title-num {
            padding-left: 3px;
            img {
              margin-right: 3px;
              margin-bottom: -3px;
            }
          }
        }
      }
      .deal-btn-wrapper {
        display: flex;
        justify-content: space-around;
        height: 42px;
        .deal-btn {
          display: inline-block;
          width: 20px;
        }
      }
    }
    .bookshelf-item:hover .info-and-deal {
      display: block;
    }
    .normal .bookshelf-bg-container img {
      max-width: 100%;
      max-height: 340px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: -1;
    }
    .add-bookshelf-div {
      color: #000;
      padding: 150px 20px;
      text-align: center;
      img {
        margin-bottom: 16px;
      }
    }
  }
  .page-component {
    position: fixed;
    background-color: #fff;
    width: calc(100% - 265px);
    bottom: 20px;
    right: 20px;
    left: 245px;
  }
  .el-dialog__wrapper {
    display: flex;
    // align-items: center;
    // justify-content: center;
    // .el-dialog {
    //   margin: 0 !important;
    //   width: 400px;
    //   .el-dialog__footer {
    //     button {
    //       width: 48%;
    //     }
    //   }
    // }
  }
}
</style>
